import React from 'react';

const SleepCenterComponent = (props) => {
  return (
    <div className='absolute flex flex-col items-center justify-center w-48 h-48 mt-6'>
      <div>
        <svg width='20' height='23' viewBox='0 0 20 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M18.9769 18.8527C18.8873 18.7525 18.7594 18.6951 18.625 18.6947L18.6294 18.6966C13.0685 18.658 8.59183 14.1187 8.63043 8.55788C8.65002 5.73735 9.85176 3.05431 11.9432 1.16177C12.1383 0.987202 12.1549 0.687506 11.9803 0.49239C11.8908 0.392219 11.7628 0.334839 11.6284 0.334438C5.53884 0.27742 0.555988 5.16773 0.498916 11.2573C0.441843 17.3468 5.33215 22.3297 11.4218 22.3868C14.1991 22.4128 16.884 21.3898 18.9398 19.5221C19.1349 19.3475 19.1515 19.0478 18.9769 18.8527Z'
            fill='#7BABDC'
          />
        </svg>
      </div>
      <span className='text-3xl font-medium leading-relaxed text-summary-header'>{props.total}</span>
      <span className='text-base text-secondary'>
        {props.t('hours')}/{props.t('day')}
      </span>
    </div>
  );
};

export default SleepCenterComponent;
